var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebsiteIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.9375C0 1.4876 1.1751 0.3125 2.625 0.3125H18.375C19.8229 0.3125 21 1.4876 21 2.9375V16.0625C21 17.5104 19.8229 18.6875 18.375 18.6875H2.625C1.1751 18.6875 0 17.5104 0 16.0625V2.9375ZM3.9375 5.5625C4.66348 5.5625 5.25 4.97598 5.25 4.25C5.25 3.52402 4.66348 2.9375 3.9375 2.9375C3.21275 2.9375 2.625 3.52402 2.625 4.25C2.625 4.97598 3.21275 5.5625 3.9375 5.5625ZM18.375 4.25C18.375 3.70449 17.9361 3.26562 17.3906 3.26562H7.54688C7.00137 3.26562 6.5625 3.70449 6.5625 4.25C6.5625 4.79551 7.00137 5.23438 7.54688 5.23438H17.3906C17.9361 5.23438 18.375 4.79551 18.375 4.25Z",
    fill: "#494949"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteIcon);
export default __webpack_public_path__ + "static/media/website-icon.945db282adf737e4cd542ff743063255.svg";
export { ForwardRef as ReactComponent };